import BasePaperSidenav from 'ember-paper/components/paper-sidenav';

class PaperSidenav extends BasePaperSidenav {}

export default PaperSidenav;
